/* styles */
import useStyles from './useStyles'
import { Checkbox } from '@mui/material'
// import { traducNameTemporal } from '../../../../utils/traducTypes'
import ModalMenuItem from '../../ModalMenu/ModalMenu'
import { useEffect, useState } from 'react'

function TableItem ({
  item,
  setLoading,
  allChecked,
  setAllChecked,
  elementsChecked,
  setElementsChecked,
  onDesbloquear,
  getUserName,
  getCustomerName
}) {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)

  const handleChange = (event) => {
    setChecked(event.target.checked)
    if (event.target.checked) {
      if (!elementsChecked.includes(item)) {
        setElementsChecked((elements) => [...elements, item])
      }
    } else if (elementsChecked.includes(item)) {
      if (allChecked) {
        setAllChecked(false)
      }
      const elementsFilter = elementsChecked.filter(
        (element) => element._id !== item._id
      )
      setElementsChecked(elementsFilter)
    }
  }

  useEffect(() => {
    if (allChecked) {
      setChecked(true)
      if (!elementsChecked.includes(item)) {
        setElementsChecked((elements) => [...elements, item])
      }
    } else if (!allChecked && elementsChecked.length === 0) {
      setChecked(false)
    }
  }, [allChecked])

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox checked={checked} onChange={handleChange} />
        </td>
        <td className={classes.itemCliente}>{getCustomerName(item.customerSuborganizationId)}</td>

        <td className={classes.itemDescr}>
          {item.personalLegalDeclarationDesc || '- -'}
        </td>

        {/* <td className={classes.itemUser}>
          {item.firmSupportStaffAssigned && item.firmSupportStaffAssigned.map((userId) => (
            <div key={userId}>{getUserName(userId)}</div>
          ))}
        </td> */}
        <td className={classes.itemUser}>
            {item.bpDeclarations && (
              <div key={item.bpDeclarations.editionUserId}>
                {getUserName(item.bpDeclarations.editionUserId)}
              </div>
            )}
        </td>
        <td className={classes.itemPeriodo}>
          {item.bpDeclarations.bpDeclarationPeriodYear || '- -'}
        </td>
        <td className={classes.itemDueDate}>
          {item.bpDeclarations.bpMaturityDueDate || '- -'}
        </td>
        <td className={classes.itemEstado}>
          {item.bpDeclarations.declarationStatusDesc || '- -'}
        </td>
        <td className={classes.itemModificada}>
          {formatDate(item.modificationDate) || '- -'}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            setLoading={setLoading}
            onDesbloquear={onDesbloquear}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
